﻿<template>

    <header class="header" >
        <header_menu></header_menu>
        <hero v-if="isValidView()" :title=getConfirmationText() :subtitle="getSubtitle()" :hero_image="getHeroImage()"></hero>
        <hero v-else title="404 (page not found)" subtitle="Whoops! You've hit a 404 (page not found). Sorry, you'll have to turn around. " :hero_image="getHeroImage()" ></hero>
        <div v-if="!isValidView()" class="flex flex-col items-center"><button type="button" class="m-10 px-10 py-2 button button-pink-book" @click="home_Click()">Return to Home Page</button></div>
    </header>

    <main class="main" v-if="isValidView()">
        
        <!--TEMPORARY MESSAGE DURING PAYMENT FAILURES-->
        <div v-if="(!isAgent_Login() && GetBrand() == 'HEX') && !Balance_Outstanding()" class="cart-addon m-10" >
            <p class="m-auto font-bold text-black pt-2 text-center">If you don't receive a confirmation email please contact us at <a href="mailto:info@highlandexplorertours.com">info@highlandexplorertours.com</a></p>
        </div>
        <div v-if="(!isAgent_Login() && GetBrand() == 'HAG') && !Balance_Outstanding()" class="cart-addon m-10" >
            <p class="m-auto font-bold text-black pt-2 text-center">If you don't receive a confirmation email please contact us at <a href="mailto:info@haggisadventures.com">info@haggisadventures.com</a></p>
        </div>

        <div v-if="(!isAgent_Login() && Balance_Outstanding())" class="flex justify-center flex-col m-auto">
            <div class="w-2/3 mx-auto p-8 md:p-2 my-3 rounded-mg shadow-1xl bg-pink-100 border-t-4 border-pink-500 rounded-b text-pink-900 px-4 py-3 shadow-md text-center" role="alert">
                <div class="flex"><div class="py-1"><svg class="fill-current h-6 w-6 text-pink-500 mr-4 mt-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"/></svg></div><div>
                    <p>
                        Payment was <b>unsuccessful</b>, <b>cancelled</b>, or if you have done a <b>part-payment</b> please check below when the remaining balance is due.
                    </p>
                    <p>
                        For further options please check below or contact us at 
                        <a v-if="GetBrand() == 'HEX'" href="mailto:info@highlandexplorertours.com">info@highlandexplorertours.com</a>
                        <a v-else-if="GetBrand() == 'HAG'" href="mailto:info@haggisadventures.com">info@haggisadventures.com</a>
                    </p>
                </div>
                </div>
            </div>
        </div>

        <div class="row mt-12" id="PaymentConfirmed">
            <h2>Booked itinerary</h2>
        </div>

        <div class="row">

            <div class="payment cart-content flex flex-col md:flex-row">

            <div class="cart-items w-full md:w-7/12 lg:w-8/12 pr-0 md:pr-4 xl:pr-8 mb-8">
                <basket></basket>
                <documentation :class="{'hidden': isAgent_Login() == false}"></documentation>
                <trip_summary class="block md:hidden mb-4"></trip_summary>
                <iframe v-if="!isAgent_Login()" :src="getFloDeskURL()" class="align-left w-full h-screen overflow-hidden" title="flodesk Iframe"></iframe>
            </div>

            <trip_summary class="hidden md:block"></trip_summary>
            </div>
         </div>

        </main>

    <footer_item></footer_item>

</template>

<script lang="ts" src="./5_confirmation.ts"></script>